export default {
  shopIndex: {
    Button: {
      postcard: "Business License",
      chatLineSquare: "Contact Customer Service",
      collectId: "Unfollow Store",
      collect: "Follow Store",
    },
    EntpInfoData: {
      entpName: "Company Name:",
      address: "Address:",
      contName: "Contact Person:",
      contTel: "Phone Number:",
      contEmail: "Email Address:",
    },
    Placeholder: {
      saleCatgName: "Please enter a keyword"
    },
    shopCommCatgList: {
      title: "Product Categories"
    },
    sort: {
      price: "Sort by Price",
      count: "Sales Volume",
      update: "Update Time"
    },
    Table: {
      egotiable: "Negotiable",
      money: "CNY",
      end: "---No More Data---"
    },
    Dialog: {
      title: "Business License",
      button: "Close"
    },
    Message: {
      shopCollect: "Store followed successfully",
      shopCollectDel: "Store unfollowed successfully"
    }
  }
}